// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/claim-widget/claim-widget.less
// module id = 3346
// module chunks = 0